import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import BlogDetailsMain from './BlogDetailsMain';
import Footer from '../../components/Footer';

const BlogDetails = () => {
  return (
    <>
      <HeaderSeven />

      <BlogDetailsMain />

      <Footer />
    </>
  );
};

export default BlogDetails;
